export class ConnectionTestSession {
    id: string;
    connectionToken: string;
    thingDefinitionName: string;
    thingId: string;
    startedAt: number;
    connectionStatus: string;
    userEmail: string;
}